<template>
  <PageMain :tableData="tableData" />
</template>

<script>
import PageMain from './main.vue'
export default {
  components: { PageMain },
  props: { tableData: { type: Array, default: () => [] } },
}
</script>
